import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "form3-container" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "tip-tabs-bar" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-name" }
const _hoisted_6 = {
  key: 0,
  class: "editor-layout"
}
const _hoisted_7 = { class: "form-area" }
const _hoisted_8 = { class: "single-uploader-card" }
const _hoisted_9 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_10 = { class: "hover-mask" }
const _hoisted_11 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_12 = { class: "preview-area" }
const _hoisted_13 = { class: "mockup-phone" }
const _hoisted_14 = { class: "phone-screen" }
const _hoisted_15 = { class: "mock-nav" }
const _hoisted_16 = { class: "nav-title" }
const _hoisted_17 = { class: "screen-scrollable" }
const _hoisted_18 = { class: "tip-preview-title" }
const _hoisted_19 = {
  key: 0,
  class: "unlocked-tip-content"
}
const _hoisted_20 = {
  key: 0,
  class: "tip-img-box"
}
const _hoisted_21 = { class: "tip-text-body" }
const _hoisted_22 = {
  key: 0,
  class: "locked-tip-placeholder"
}
const _hoisted_23 = { class: "lock-icon-circle" }
const _hoisted_24 = { class: "screen-footer" }
const _hoisted_25 = {
  key: 1,
  class: "empty-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header-left" }, [
        _createElementVNode("h2", { class: "section-title" }, "关卡谜题提示配置"),
        _createElementVNode("span", { class: "section-tip" }, "最多支持 4 级逐级引导提示，右侧可点击体验 App 端遮罩解密效果")
      ], -1)),
      _createVNode(_component_el_button, {
        type: "primary",
        icon: _ctx.Plus,
        class: "add-tip-btn",
        disabled: _ctx.fileList2.length >= 4,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addTip(_ctx.detailId)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 新增提示 (" + _toDisplayString(_ctx.fileList2.length) + "/4) ", 1)
        ]),
        _: 1
      }, 8, ["icon", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_VueDraggable, {
        ref: "el",
        modelValue: _ctx.fileList2,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList2) = $event)),
        class: "draggable-tip-tabs",
        animation: 150
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList2, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id || index,
              class: _normalizeClass(['tip-tab-chip', { active: _ctx.activeIndex === index }]),
              onClick: ($event: any) => (_ctx.changeTip(index))
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "drag-handle" }, [
                _createElementVNode("span", { class: "dot" }),
                _createElementVNode("span", { class: "dot" })
              ], -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(`提示 ${index + 1}`), 1),
              _createVNode(_component_el_icon, {
                class: "tab-close",
                title: "删除此提示",
                onClick: _withModifiers(($event: any) => (_ctx.deleteTip(index, $event)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Close)
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 10, _hoisted_4))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (_ctx.fileList2.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              "label-width": "auto",
              "label-position": "top",
              rules: _ctx.rules,
              ref: "ruleForm",
              "status-icon": "",
              class: "custom-form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "提示标题",
                  prop: "puzzleTitle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.puzzleTitle,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.puzzleTitle) = $event)),
                      placeholder: "例如：关于书架暗格的线索",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "提示正文内容",
                  prop: "puzzleContent"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.puzzleContent,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.puzzleContent) = $event)),
                      type: "textarea",
                      rows: 7,
                      maxlength: "1000",
                      "show-word-limit": "",
                      placeholder: "请输入循序渐进的引导文字，帮助玩家解开谜题..."
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "提示参考附图（选填）",
                  prop: "puzzleCover"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_upload, {
                        class: "uploader-box",
                        action: _ctx.UpdateApi,
                        "show-file-list": false,
                        "on-success": _ctx.handleAvatarSuccess,
                        "before-upload": _ctx.beforeAvatarUpload,
                        disabled: _ctx.allowUpload
                      }, {
                        default: _withCtx(() => [
                          (_ctx.form.puzzleCover)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_el_image, {
                                  src: _ctx.form.puzzleCover,
                                  class: "img-content",
                                  fit: "cover"
                                }, null, 8, ["src"]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("span", {
                                    class: "del-btn",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)), ["stop"])),
                                    title: "删除图片"
                                  }, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Delete)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_el_icon, { class: "icon" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                }),
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text" }, "上传提示配图", -1)),
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                              ]))
                        ]),
                        _: 1
                      }, 8, ["action", "on-success", "before-upload", "disabled"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "preview-header" }, [
              _createElementVNode("span", { class: "badge-dot" }),
              _createElementVNode("span", null, "移动端解密效果预览")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "phone-top-bar" }, [
                _createElementVNode("div", { class: "notch" })
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowLeft)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(`关卡提示 (${_ctx.activeIndex + 1}/${_ctx.fileList2.length})`), 1),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowRight)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.form.puzzleTitle || "提示标题占位"), 1),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.showTip)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_ctx.form.puzzleCover)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createVNode(_component_el_image, {
                                    src: _ctx.form.puzzleCover,
                                    fit: "cover",
                                    class: "tip-img"
                                  }, null, 8, ["src"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.form.puzzleContent || "这里展示详细的文字线索指引..."), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!_ctx.showTip)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "lock-title" }, "提示内容已锁定", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "lock-sub" }, "点击下方按钮可消耗积分查看本条线索", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: _normalizeClass(['mock-action-btn', { active: _ctx.showTip }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showTip = !_ctx.showTip))
                  }, _toDisplayString(_ctx.showTip ? "收起提示内容" : "开启并查看提示"), 3)
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_el_icon, { class: "empty-icon" }, {
            default: _withCtx(() => [
              _createVNode(_component_InfoFilled)
            ]),
            _: 1
          }),
          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "empty-title" }, "当前关卡尚未创建任何提示", -1)),
          _cache[17] || (_cache[17] = _createElementVNode("p", { class: "empty-desc" }, "建议添加 1~2 条梯度提示，避免玩家因卡关而流失", -1)),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            icon: _ctx.Plus,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addTip(_ctx.detailId)))
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode(" 立即创建第 1 条提示 ", -1)
            ]))]),
            _: 1
          }, 8, ["icon"])
        ]))
  ]))
}